import { InMemoryCache, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { authApiClient, AuthState } from "./authApiClient";
import { constants } from "../constants";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";

const httpLink = createUploadLink({
  uri: constants.GRAPHQL_API_URL,
});

const authLink = setContext(async (_, { headers }) => {
  if (authApiClient.authState === AuthState.TOKEN_EXPIRED) {
    await authApiClient.refreshApiTokens();
  }
  return {
    headers: {
      ...headers,
      authorization: `Bearer ${authApiClient.zeemeeApiToken}`,
    },
  };
});

const refreshTokenLink = onError(({ networkError, operation, forward }) => {
  if (
    networkError &&
    "statusCode" in networkError &&
    networkError.statusCode === 401
  ) {
    if (operation.operationName !== "IntrospectionQuery") {
      authApiClient.authState = AuthState.TOKEN_EXPIRED;
      // retry request
      return forward(operation);
    }
  }
});

export const apolloLink = from([refreshTokenLink, authLink, httpLink]);

export const cache = new InMemoryCache({
  typePolicies: {
    User: {
      fields: {
        name: {
          read: (_, { readField }) =>
            [readField("firstName"), readField("lastName")]
              .filter((name) => name)
              .join(" "),
        },
      },
    },
    Student: {
      fields: {
        studentOrganizationStatus: {
          merge(existing, incoming, { mergeObjects }) {
            return mergeObjects(existing, incoming);
          },
        },
      },
    },
    Organization: {
      fields: {
        rise: {
          merge(existing, incoming) {
            return { ...existing, ...incoming };
          },
        },
      },
    },
  },
});
